module.exports = __webpack_public_path__ + "media/images/preview-85ae2bd18c28580994d514f032370a95.svg";